import {starSvg as Icon__small__starSvg} from '../Icon__small/Icon__small--star.js'

export var star = {
  name: 'star',
  category: 'icon',
  colorable: true,
  svg: Icon__small__starSvg,
};
